import React from "react";
import { useSelector } from "react-redux";
import styles from "./MineControls.module.css";
import clickAudio from "../../audios/click.mp3";
import useSound from "use-sound";
import getSoundEffectVolume from "../../utils/getSoundEffectVolume";

const MineControls = ({ onChange, value }) => {
  const sounds = useSelector((state) => state.sounds);

  const [playClickSound] = useSound(clickAudio, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const clickSound = () => {
    playClickSound();
  };

  return (
    <div className={styles.controlGroup}>
      <label className={styles.inputLabel}>Mines</label>
      <select
        className={styles.selectField}
        onChange={(e) => {
          clickSound();
          onChange(parseInt(e.target.value));
          localStorage.setItem("minesAmount", parseInt(e.target.value));
        }}
        // defaultValue={value}
        value={value}
      >
        {[...Array(24)]
          .map((_, i) => i + 1)
          .map((i) => (
            <option key={i} value={i}>
              {i}
            </option>
          ))}
      </select>
    </div>
  );
};

export default MineControls;
